export const MarketingRibbonTypesEnum = {
  Recommended: "Recommended",
  Bestseller: "Bestseller",
};
